// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// Import definitions
import { getLoopFilter } from '@automator/builder/definitions/items';

// Import recipe builder services
import { deleteLoopFilter } from '@automator/builder/services/item/loop';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-loop-filter-btn-delete' )
export class AutomatorBuilderItemLoopFilterDelete extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	// The unique ID of the loop (parent of this loop filter)
	@property( { type: Number, attribute: 'loop-id' } ) accessor loopID;

	// The unique ID of this loop filter
	@property( { type: Number, attribute: 'loop-filter-id' } ) accessor loopFilterID;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-tooltip>
				${ escapeHTML( __( 'Delete filter', 'uncanny-automator' ) ) }
				
				<uo-button 
					class="remove" 
					color="transparent" 
					size="small"
					slot="target"

					@click=${ this.handleDeleteFilter }
				>
					<uo-icon id="trash"></uo-icon>
				</uo-button>
			</uo-tooltip>
		`;
	}

	/**
	 * Handles the deletion of this loop filter
	 */
	handleDeleteFilter() {
		deleteLoopFilter(
			this.loopID,
			this.loopFilterID,
		);
	}

	/**
	 * Returns the global/directory data of this item
	 *
	 * @return {Object} The directory data of this item. This contains, for example, the fields attributes
	 */
	get directoryItemData() {
		return getLoopFilter(
			this.integrationCode,
			this.code
		);
	}
}